import { createRequestTypes } from '../utils';

export const FETCH_SUBSTANCE_CLPS = createRequestTypes('substanceClp/FETCH_SUBSTANCE_CLPS');
export const DELETE_SUBSTANCE_CLP = createRequestTypes('substanceClp/DELETE_SUBSTANCE_CLP');
export const SAVE_SUBSTANCE_CLP = createRequestTypes('substanceClp/SAVE_SUBSTANCE_CLP');
